<template>
  <div :class="`w-full ${bgClass} px-5`">
    <div
      class="flex flex-row py-0 bg-secondary w-full md:w-[90%] mx-auto min-w-[256px] min-h-[60px] overflow-x-scroll justify-start line-clamp-1"
      id="categories-container"
    >
      <div
        v-for="category of filteredCategories"
        :key="category._id"
        :id="`link-${category._id}`"
        :class="`p-3 hover:cursor-pointer transition-all my-1 uppercase whitespace-nowrap text-center grow ${btnClass(
          category
        )}`"
        @click="scrollTo(category)"
      >
        <img
          class="h-5 w-5"
          :src="category.icon.icon"
          v-if="category && category.icon"
        />{{ category.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useCategoryStore } from "@/app-store/category";
import { useAppStore } from "@/app-store/app";
import { isCategoryAvailable } from "@/utils/General";

export default {
  name: "CategoriesMenu",
  data() {
    return {
      currentCategoryId: null,
    };
  },
  computed: {
    ...mapWritableState(useCategoryStore, ["categories"]),
    ...mapState(useAppStore, ["platform", "layoutConfig"]),
    bgClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.menu) return "bg-color-first";
      return `bg-color-${layoutConfig.menu.categoryContainerColor} text-color-${layoutConfig.menu.categoryButtonTextColor} font-${layoutConfig.menu.categoryButtonFont} text-xl md:text-${layoutConfig.menu.categoryButtonTextSize}`;
    },
    filteredCategories() {
      return this.categories.filter(isCategoryAvailable);
    },
  },
  methods: {
    btnClass(category) {
      const { layoutConfig, currentCategoryId } = this;

      if (
        !layoutConfig ||
        !layoutConfig.menu ||
        (layoutConfig.menu && currentCategoryId !== category._id)
      )
        return " border-color-first";
      return ` font-bold md:font-base border-2 border-color-${layoutConfig.menu.categoryButtonBorderColor}`;
    },
    scrollTo(category) {
      this.currentCategoryId = category._id;
      document.getElementById("webContent").scrollTo({
        top: document.getElementById(category._id).offsetTop - 140,
        behavior: "auto",
      });
    },
    setScrollListener() {
      document.getElementById("webContent").onscroll = () => {
        const sections = document.querySelectorAll(".products-container");
        const scrollPos =
          (document.getElementById("webContent").scrollTop ||
            document.body.scrollTop) + 140;
        let id;
        for (let s in sections) {
          if (sections[s].offsetTop <= scrollPos) {
            id = sections[s].id;
          }
        }
        if (id !== this.currentCategoryId) this.currentCategoryId = id;
      };
    },
  },
  mounted() {
    if (this.categories) {
      this.setScrollListener();
    }
    if (!this.$route.query) this.currentCategoryId = this.categories[0]._id;
  },
  watch: {
    categories(newVal) {
      if (newVal && newVal.length > 0) {
        this.currentCategoryId = newVal[0]._id;
        this.setScrollListener();
      }
    },
    currentCategoryId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (document.getElementById(`link-${newVal}`))
          document.getElementById("categories-container").scrollTo({
            left:
              document.getElementById(`link-${newVal}`).offsetLeft -
              document.getElementById(`link-${newVal}`).clientWidth,
            behavior: "smooth",
          });
      }
    },
  },
};
</script>

<style scoped></style>
